import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/cc-apple-pay': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M302.2 218.4c0 17.2-10.5 27.1-29 27.1h-24.3v-54.2h24.4c18.4 0 28.9 9.8 28.9 27.1zM349.7 281c0-8.6 6.9-13.5 20.2-14.4l23.5-1.5v7.7c0 12.8-10.8 21.9-25.2 21.9-11.3 0-18.5-5.4-18.5-13.7zM576 79v352c0 26.5-21.5 48-48 48h-480c-26.5 0-48-21.5-48-48v-352c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48zM127.8 197.2c8.4 0.7 16.8-4.2 22.1-10.4 5.2-6.4 8.6-15 7.7-23.7-7.4 0.3-16.6 4.9-21.9 11.3-4.8 5.5-8.9 14.4-7.9 22.8zM188.4 271.7c-0.2-0.2-19.6-7.6-19.8-30-0.2-18.7 15.3-27.7 16-28.2-8.8-13-22.4-14.4-27.1-14.7-12.2-0.7-22.6 6.9-28.4 6.9-5.9 0-14.7-6.6-24.3-6.4-12.5 0.2-24.2 7.3-30.5 18.6-13.1 22.6-3.4 56 9.3 74.4 6.2 9.1 13.7 19.1 23.5 18.7 9.3-0.4 13-6 24.2-6 11.3 0 14.5 6 24.3 5.9 10.2-0.2 16.5-9.1 22.8-18.2 6.9-10.4 9.8-20.4 10-21zM323.8 218.3c0-26.6-18.5-44.8-44.9-44.8h-51.2v136.4h21.2v-46.6h29.3c26.8 0 45.6-18.4 45.6-45zM413.8 242c0-19.7-15.8-32.4-40-32.4-22.5 0-39.1 12.9-39.7 30.5h19.1c1.6-8.4 9.4-13.9 20-13.9 13 0 20.2 6 20.2 17.2v7.5l-26.4 1.6c-24.6 1.5-37.9 11.6-37.9 29.1 0 17.7 13.7 29.4 33.4 29.4 13.3 0 25.6-6.7 31.2-17.4h0.4v16.4h19.6v-68h0.1zM516 210.9h-21.5l-24.9 80.6h-0.4l-24.9-80.6h-22.3l35.9 99.3-1.9 6c-3.2 10.2-8.5 14.2-17.9 14.2-1.7 0-4.9-0.2-6.2-0.3v16.4c1.2 0.4 6.5 0.5 8.1 0.5 20.7 0 30.4-7.9 38.9-31.8z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/cc-apple-pay.js
// module id = 742
// module chunks = 0